import { render, staticRenderFns } from "./equityPersonnel.vue?vue&type=template&id=e32245a4&scoped=true&"
import script from "./equityPersonnel.vue?vue&type=script&lang=js&"
export * from "./equityPersonnel.vue?vue&type=script&lang=js&"
import style0 from "./equityPersonnel.vue?vue&type=style&index=0&id=e32245a4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e32245a4",
  null
  
)

export default component.exports